<p-dialog header="Import" (onHide)="cancelImport()" [(visible)]="display" [style]="{width: '60vw'}" [modal]="true"
  [baseZIndex]="10000" class="no-padding-top">
  <p-tabView class="no-padding" [(activeIndex)]="activeIndex">
    <p-tabPanel header="Scan Items" *ngIf="!hideBulkScan && !fromPO && importForAllProducts">
      <form [formGroup]="trackingForm">
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-md-9">
            <label>{{displayName('serializedChecked', 'label')}}
              <span style="float: right;">{{listLength}} / {{importCount}}</span>
            </label>
            <ng-container [ngSwitch]="displayName('serializedChecked','control')">
              <ng-container *ngSwitchCase="'Decimal'">
                <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo"
                  (keydown.enter)="countNameList(trackingForm.value)" />
              </ng-container>
              <ng-container *ngSwitchCase="'Number'">
                <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo"
                  (keydown.enter)="countNameList(trackingForm.value)" />
              </ng-container>
              <ng-container *ngSwitchDefault>
                <input pInputText name="number" id="number" formControlName="serialNo"
                  (keydown.enter)="countNameList(trackingForm.value)" [readonly]="isAutoGenerated">
                <div
                  *ngIf="trackingForm.controls['serialNo'].invalid && (trackingForm.controls['serialNo'].dirty || trackingForm.controls['serialNo'].touched)"
                  class="p-invalid">
                  <div *ngIf="trackingForm.controls['serialNo'].errors.pattern">
                    Only alphanumeric characters are allowed.
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="p-col-12 p-md-3">
            <button type="button" pButton label="Add" class="p-mt-5 p-ml-2" (click)="countNameList(trackingForm.value)"
              [disabled]="!trackingForm.valid || !trackingForm.controls['serialNo'].value || listLength == importCount"></button>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12">
            <p-table [value]="nameLists" [lazy]="true" [paginator]="true" [first]="first" [totalRecords]="totalTBRecord"
              [rows]="pageSize" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadSerialsLazy($event)">
              <ng-template pTemplate="header">
                <tr>
                  <th id="serialNo">{{displayName('serializedChecked', 'label')}}</th>
                  <th id="setting">Matched</th>
                  <th id="delete" style="width: 2rem;">
                    <p-checkbox binary="true" [(ngModel)]="allChecked" (onChange)="setTableCheck()"
                      [ngModelOptions]="{ standalone: true }"></p-checkbox>
                  </th>
                  <th style="width: 3rem" *ngIf="allChecked" id="deleteAll">
                    <span class="btnBars p-mt-0" (click)="deleteAll()">
                      <i class="pi pi-trash" pTooltip="Delete All" tooltipPosition="top"></i>
                    </span>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product let-i="rowIndex">
                <tr>
                  <td>
                    {{product.serialNo}}
                  </td>
                  <td>
                    <span *ngIf="product.systemPresent"><i class="pi pi-check"
                        style="font-size: 1.5rem; color: green"></i></span>
                    <span *ngIf="!product.systemPresent"><i class="pi pi-times"
                        style="font-size: 1.5rem; color: red"></i></span>
                  </td>
                  <td>
                    <p-checkbox [value]="product" [(ngModel)]="product.checked" [ngModelOptions]="{standalone: true}"
                      binary="true" (onChange)="setMainHeaderTracking()"></p-checkbox>
                  </td>
                  <td class="action">
                    <span class="btnBars p-mt-0" *ngIf="product.checked" (click)="removeNumber(i,product)">
                      <i class="pi pi-trash"></i>
                    </span>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td colspan="7" class="p-text-center">
                    No Data Found.
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </form>
    </p-tabPanel>
    <p-tabPanel header="Import from file">
      <div class="card">
        <div class="p-grid" *ngIf="importForAllProducts && fromPO">
          <div class="p-col-12 p-lg-6">
            <label>Item Receipt/Bill No. <span style="color: red;">*</span></label>
            <p-dropdown placeholder="Select" optionLabel="customName" appendTo="body" [showClear]="true"
              [options]="rpoList" [(ngModel)]="selectedRPO" (onChange)="getImportCount()">
              <ng-template let-item pTemplate="selectedItem">
                {{item.pono}} - {{item.customName}}
              </ng-template>
              <ng-template let-obj pTemplate="item">
                {{obj.pono}} - {{obj.customName}}
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-3" *ngIf="serialOnly && showWarehouse">
            <label>Location<span style="color: red;">*</span></label>
            <p-dropdown placeholder="Select location" optionLabel="customName" appendTo="body" [showClear]="true"
              [options]="warehouseList" [(ngModel)]="selectedLocation" filter="true">
              <ng-template let-item pTemplate="selectedItem">
                {{item.customName}}
              </ng-template>
              <ng-template let-obj pTemplate="item">
                {{obj.customName}}
              </ng-template>
            </p-dropdown>
          </div>
          <div class="p-col-12 p-lg-3" *ngIf="!serialOnly && showWarehouse">
            <label>Month/Year<span style="color: red;">*</span></label>
            <p-calendar [(ngModel)]="date" view="month" dateFormat="MM yy" (onSelect)="onDateSelect($event)"
              [showIcon]="true" [readonlyInput]="true" appendTo="body" [maxDate]="maxDate"></p-calendar>
          </div>
          <div class="p-col-12 p-lg-3" *ngIf="!serialOnly && showWarehouse">
            <label>Batch<span style="color: red;">*</span></label>
            <p-dropdown placeholder="Select batch" optionLabel="name" appendTo="body" [showClear]="true"
              [options]="batchList" (onChange)="onBatchChange()" [(ngModel)]="selectedBatch" filter="true">
            </p-dropdown>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Action</label>
            <ng-container *ngFor="let action of actions" class="p-field-checkbox">
              <p-radioButton name="action" [value]="action"
              [(ngModel)]="selectedAction"></p-radioButton>&nbsp;{{action?.name}}
            </ng-container>
          </div>
          <div class="p-col-12 p-lg-6">
            <label class="pointer" style="color: var(--primary-color); width: fit-content; float: right;"
              (click)="downloadFile()">
              <span class="pi pi-download"></span>
              Download Format File
            </label>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <p-fileUpload #fileInput [files]="files" name="files[]" (onSelect)="onSelect($event)"
              [disabled]="importForAllProducts && !selectedRPO && fromPO"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              maxFileSize="10000000" [showUploadButton]="false" #uploader (onClear)="onClear()" (onRemove)="onRemove()">
            </p-fileUpload>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Revert Imported data" *ngIf="showWarehouse">
      <app-revert-serial-import [typeId]="serialTypeId" (onRevert)="onRevert()"></app-revert-serial-import>
    </p-tabPanel>
  </p-tabView>
  <p-footer>
    <button type="button" class="p-mt-2" [disabled]="isDisabled || (importForAllProducts && !selectedRPO && fromPO) || (showWarehouse && (serialOnly && !selectedLocation) || (!serialOnly && (!date || !selectedBatch)))" pButton label="Save"
      *ngIf="(hideBulkScan || !fromPO) && uploader.files.length > 0 && excelFileData?.length>0"
      (click)="save()"></button>
    <button type="button" pButton *ngIf="activeIndex==0 && !hideBulkScan" (click)="scanSerials()"
      class="p-button-label p-mt-2" label="Save"></button>
    <button type="button" pButton (click)="mappingData()" class="p-button-label p-mt-2" label="Next"
      *ngIf="!displayFieldMapping && excelFileData?.length==0" [disabled]="!selectedFile || buttonDisabled"></button>
  </p-footer>
</p-dialog>

<!-- Download template field -->
<p-dialog header="Template Settings" [(visible)]="displayOptions" [style]="{width: '450px'}" [modal]="true">
    <div class="p-grid" style="height: 400px;">
        <div class="p-col-12 p-lg-8">
            <div class="card">
                    <div>
                        <ng-container *ngFor="let col of optionFields; let i = index">
                            <div class="colList p-d-flex" appendTo="body">
                                <i class="fa fa-bars"
                                    style="margin-right: 10px; color:lightgray"></i>
                                <p-checkbox [(ngModel)]="col.checked" type="checkbox" binary="true" inputId="binary"
                                   class="p-mr-2"></p-checkbox>
                                &nbsp;&nbsp;{{col.name}}
                            </div>
                        </ng-container>
                    </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="displayOptions=false" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button (click)="prepopulateData()" label="Next" [disabled]="disabledOptionDialog"></p-button>
    </ng-template>
</p-dialog>

@if(displayBatchForm){
<app-addedit-batch [displayBatchForm]="displayBatchForm" [batchList]="batchList" [batchGroup]="batchGroup"
  [addFlag]="true" [batchData]="null" (onClose)="closeBatchDialog()" (onSaveBatch)="onSaveBatch()"></app-addedit-batch>
}

@if(displayFieldMapping){
  <app-shared-import-field-mapping [displayFieldMapping]="displayFieldMapping" [selectedModule]="selectedModule"
    [selectedChannel]="selectedChannel" [sectionColumns]="referenceFields" [selectedFile]="selectedFile"
    [selectedFileHeaders]="selectedFileHeaders" [selectedAction]="selectedAction" (dialogClosed)="closMappingModal()"
    (importStarted)="importFileUploaded($event)">
  </app-shared-import-field-mapping>
  }

<p-confirmDialog *ngIf="showWarehouse" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
<p-toast *ngIf="showWarehouse" [baseZIndex]="1000000"></p-toast>

